import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import {
  media,
  getValue,
  toCurrency,
  toPercentage,
} from '@deerplusofficial/pos-helper';
import Icon from '../Icon/Icon';
import Key, { Button } from './Key';

const PrepIcon = styled(Icon)`
  margin-right: 0.5em;
`;

const keys = [
  '7',
  '8',
  '9',
  '4',
  '5',
  '6',
  '1',
  '2',
  '3',
  '',
  '0',
  'Backspace',
];

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 20px auto 10px;
  width: 100%;
`;

const ButtonText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 55px;
  font-size: 18px;
  color: #ffffff;
  ${props =>
    props.large &&
    media(
      'tablet',
      css`
        height: 67px;
      `
    )};
`;

export default class Calculator extends PureComponent {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    advanced: PropTypes.bool,
    large: PropTypes.bool,
    onChange: PropTypes.func,
    mode: PropTypes.oneOf(['auto', 'keyboard', 'amount']),
  };

  static defaultProps = {
    value: '',
    advanced: false,
    large: false,
    onChange: _.identity,
    mode: 'auto',
  };

  onRateModeEnable = () => {
    if (this.mode === 'rate') return;

    const { onChange, value } = this.props;
    const newValue = _.floor(getValue(value) / 100, 2);

    onChange(toPercentage(newValue));
  };

  onPriceModeEnable = () => {
    if (this.mode === 'price') return;

    const { onChange, value } = this.props;
    const newValue = _.floor(getValue(value) * 100, 0);

    onChange(toCurrency(newValue));
  };

  onBackspacePress = () => {
    const { onChange, value } = this.props;
    switch (this.mode) {
      case 'price':
        onChange(toCurrency(_.floor(getValue(value) / 10, 0)));
        break;
      case 'rate':
        onChange(toPercentage(_.floor(getValue(value) / 10, 2)));
        break;
      case 'amount':
        onChange(_.floor(getValue(value) / 10, 0));
        break;
      default:
        onChange(value.slice(0, -1));
        break;
    }
  };

  onButtonPress = ({ key }) => {
    const { onChange, value } = this.props;
    const isValidKey = _.includes(keys, key);

    if (!isValidKey || key === '.') return;

    if (key === 'Backspace') return this.onBackspacePress();

    const inputValue = _.toNumber(key);
    switch (this.mode) {
      case 'price':
        onChange(toCurrency(getValue(value) * 10 + inputValue));
        break;
      case 'rate':
        onChange(toPercentage((getValue(value) * 1000 + inputValue) / 100));
        break;
      case 'amount':
        onChange(getValue(value) * 10 + inputValue);
        break;
      default:
        onChange(`${value}${key}`);
        break;
    }
  };

  get mode() {
    const { value, mode } = this.props;

    if (mode === 'auto') return /%/.test(value) ? 'rate' : 'price';

    return mode;
  }

  renderButton = key => {
    const { large } = this.props;

    return (
      <Key
        key={key}
        name={key}
        onClick={this.onButtonPress}
        disabled={_.size(key) === 0}
      >
        <ButtonText large={large}>
          {key === 'Backspace' ? <Icon icon="backspace" /> : key}
        </ButtonText>
      </Key>
    );
  };

  render() {
    const { advanced, large } = this.props;

    return (
      <Container onKeyDown={this.onButtonPress}>
        {_.map(keys, key => this.renderButton(key))}
        {advanced && (
          <React.Fragment>
            <Button onClick={this.onPriceModeEnable}>
              <ButtonText large={large}>
                <PrepIcon icon="dollar-sign" />
                折扣金額
              </ButtonText>
            </Button>
            <Button onClick={this.onRateModeEnable}>
              <ButtonText large={large}>
                <PrepIcon icon="percent" />
                折扣比例
              </ButtonText>
            </Button>
          </React.Fragment>
        )}
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ../pos-master/packages/pos-components/src/Calculator/Calculator.jsx